import { Room } from 'Interfaces/ReferenceInterfaces/RoomInterface';
import { observer } from 'mobx-react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ProgressSpinner } from 'primereact/progressspinner';
import classes from './roomsTable.module.scss';
import { useRoomsTable } from './useRoomTable';

interface RoomsTableProps {
  showAllRows?: boolean;
}

const RoomsTable = observer(({ showAllRows = true }: RoomsTableProps) => {
  const pageSize = showAllRows ? 100000 : 100;
  const { roomData, isLoading } = useRoomsTable(pageSize);

  const roomTypeBodyTemplate = (rowData: Room) => {
    return rowData.room_type?.description || 'N/A';
  };

  if (isLoading && !roomData.length) {
    return (
      <div className={classes.loadingContainer}>
        <ProgressSpinner className={classes.spinner} />
      </div>
    );
  }

  return (
    <div className={classes.roomsTable}>
      <div className={classes.tableHeader}>
        <h2 className={classes.sectionTitle}>Room Configuration</h2>
      </div>

      <DataTable
        value={roomData}
        showGridlines
        stripedRows
        emptyMessage="No records found"
        className={classes.dataTable}
        loading={isLoading}
      >
        <Column field="room_short" header="Room Short Name" />
        <Column field="room_long" header="Room Long Name" />
        <Column body={roomTypeBodyTemplate} header="Room Type" />
      </DataTable>
    </div>
  );
});

export default RoomsTable;
